// import Select from 'react-select'

interface Props {
  disabled?: boolean
  idx: number
  name: string
  distance: string
  onChange: (key: string, value: any) => void
}

const FACTORY_OPTIONS = [
  {
    label: 'The Pathumthani Concrete PACO (Plant 1) <br/>Tel. 02-587-0199',
    value: 'PACO_1',
  },
  {
    label: 'The Pathumthani Concrete PACO (Plant 2) <br/>Tel. 02-599-1274',
    value: 'PACO_2',
  },
  {
    label: 'ปทุมธานีคอนกรีต (โรงงาน 3) <br/>Tel. 03-365-0050',
    value: 'PACO_3',
  },
]

const InstallationFactoryDistanceItem: React.FC<Props> = ({
  disabled,
  idx,
  name,
  distance,
  onChange,
}) => {
  return (
    <div className='row gy-5'>
      <div
        className='col-12 col-xl-3'
        dangerouslySetInnerHTML={{ __html: FACTORY_OPTIONS[idx].label }}></div>
      <div className='col-12 col-xl-2'>
        <div className='position-relative'>
          <input
            disabled={disabled}
            name={name + '-distance'}
            className='form-control form-control-sm'
            value={distance}
            onChange={(e: any) => onChange('distance', e.target.value)}
          />
          <div className='position-absolute text-gray-500' style={{ top: '22%', right: 10 }}>
            (กิโลเมตร)
          </div>
        </div>
      </div>
      {/* <div className="d-none d-xl-block col-xl-4"></div>

          <div className='col-12 col-xl-2'>โรงงาน: </div>
          <div className='col-12 col-xl-6'>
            <Select
              name={`distanceFromFactoryKm3`}
              isSearchable={true}
              isClearable
              options={FACTORY_OPTIONS}
              styles={{
                control: (provided  :any) =>  ({
                  ...provided,
                  borderColor: '#e1e3ea',
                }),
              }}
              value={FACTORY_OPTIONS.find(option => option.value === factory) ?? null}
              onChange={(val :any) => {
                onChange('factory', val?.value)
              }}
            />
          </div> */}
    </div>
  )
}

export default InstallationFactoryDistanceItem
